
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PendingVerificationLegalEntitySearchResultResource,
  PendingVerificationLegalEntitySortDirection,
  PendingVerificationLegalEntitySortField,
  ValidationError,
} from '../models';
import {
    PendingVerificationLegalEntitySearchResultResourceFromJSON,
    PendingVerificationLegalEntitySearchResultResourceToJSON,
    PendingVerificationLegalEntitySortDirectionFromJSON,
    PendingVerificationLegalEntitySortDirectionToJSON,
    PendingVerificationLegalEntitySortFieldFromJSON,
    PendingVerificationLegalEntitySortFieldToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface SearchPendingVerificationLegalEntitiesRequest {
    searchText?: string;
    organizationIds?: Array<string>;
    countryCodes?: Array<string>;
    hasRequestedVerification?: boolean;
    sortField?: PendingVerificationLegalEntitySortField;
    sortDirection?: PendingVerificationLegalEntitySortDirection;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class PendingVerificationLegalEntityAdminApi extends runtime.BaseAPI {

    /**
     * Search for client legal entities pending manual verification (admin endpoint)
          */
    async searchPendingVerificationLegalEntitiesRaw(requestParameters: SearchPendingVerificationLegalEntitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PendingVerificationLegalEntitySearchResultResource>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['organizationIds'] != null) {
            queryParameters['organizationIds'] = requestParameters['organizationIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['countryCodes'] != null) {
            queryParameters['countryCodes'] = requestParameters['countryCodes']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['hasRequestedVerification'] != null) {
            queryParameters['hasRequestedVerification'] = requestParameters['hasRequestedVerification'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<PendingVerificationLegalEntitySearchResultResource>({
            path: `/compliance/api/admin/legal-entities/pending-verification`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=PendingVerificationLegalEntitySearchResultResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Search for client legal entities pending manual verification (admin endpoint)
          */
    async searchPendingVerificationLegalEntities(requestParameters: SearchPendingVerificationLegalEntitiesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PendingVerificationLegalEntitySearchResultResource> {
        const response = await this.searchPendingVerificationLegalEntitiesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
